import { createContext } from 'react';

var TranslationContext = createContext({});

export { TranslationContext };
